import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Autocomplete2 from "@material-ui/lab/Autocomplete";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";

export default function FormDialog(props) {
  try {
    var Autorizacion2 = JSON.parse(localStorage.getItem("Permisos"));
    //console.log('Los permisos: ', JSON.parse(Autorizacion));
    if (!window.respuesta) {
      window.respuesta = Autorizacion2;
    }
    console.log("los permisos ", window.respuesta);
  } catch (err) {
    console.log(err);
  }

  console.log(props);
  const handleClose = () => {
    props.newNoteBtnClick();
  };

  return (
    <div>
      <form
        //className={classes.container}
        onSubmit={props.newNote}
        autoComplete="off"
      >
        <DialogTitle id="form-dialog-title">Alta de Caso</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Debe elegir o crear un usuario para crear un caso
          </DialogContentText>

          <Autocomplete2
            id="boxUsuario"
            // className={classes.textField}
            value={props.usuario}
            onChange={(obj, str) => props.updateUsuario(str)}
            onClose={params => console.log(params.target.value, "on closee!!")}
            options={
              props.listaUsuarios
                ? props.listaUsuarios
                    .filter(i => i.rol === "cliente")
                    .map(i => {
                      return i.nombre;
                    })
                : null
            }
            //getOptionLabel={option => option.nombre}
            renderInput={params => (
              <TextField
                {...params}
                label="Cliente"
                margin="normal"
                variant="outlined"
                required
                fullWidth
              />
            )}
          />
          {/*** CORREO ELECTRONICO ***/}
          <TextField
            margin="dense"
            id="email"
            value={props.email}
            label="correo electronico"
            variant="outlined"
            type="name"
            required
            fullWidth
            disabled
          />
        </DialogContent>

        <DialogActions>
          {window.respuesta.checkedH ? (
            <IconButton
              style={{ width: "40px" }}
              aria-label="delete"
              color="primary"
              onClick={() => props.NuevoUsuario()}
            >
              <AddCircleIcon />
            </IconButton>
          ) : null}
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>

          <Button /*onClick={props.newNote}*/ type="submit" color="primary">
            Crear
          </Button>
        </DialogActions>
      </form>
    </div>
  );
}
